export default {
  primary: 'linear-gradient(90deg, #FC6244 0%, #FC9256 98.89%)',
  secondary: 'linear-gradient(90deg, #1A202B 0%, #3B557A 98.89%)',
};
